import React from "react";

/* ─── Custom Detail Card (Figma Match) ─── */
const PlacementDetailCard = ({ title, children, headeRight, headerLeft, className }) => (
  <div className={`w-full flex flex-col rounded-lg border border-gray-200 overflow-hidden ${className || ""}`}>
    <div className="flex justify-between gap-2 items-center bg-[#f9f9f9] border-b border-gray-200 p-3">
      <div>{headerLeft || title}</div>
      <div>{headeRight}</div>
    </div>
    <div className="p-3 bg-white min-h-16 w-full">
      <div className="w-full">
        {children}
      </div>
    </div>
  </div>
);

export default PlacementDetailCard;
